const TIPS = {
  Hwt: "Highweight handicap: scored as a 40 class race",
  Picnic: "Picnic race: scored as a 38 class race, last start weight change ignored",
  Amateur: "Amateur race: scored as a 38 class race",
  "<$10k": "Race under $9,999 prizemoney: scored as a 38 class race",
};

export const RaceTypeBadge = ({ type, testId }) => type ? (
  <span title={TIPS[type] || `${type}: fixed class score, any day or venue`} data-testid={testId}
    className="inline-flex items-center shrink-0 text-[10px] font-mono font-bold uppercase tracking-wider px-1.5 py-0.5 rounded bg-sky-500/15 text-sky-300 border border-sky-500/40">
    {type}
  </span>
) : null;
